<template>
  <v-slide-y-transition>
    <div v-if="loanData">
      <div class="pb-4">
        <p class="mb-0 color--nice-grey">신청 금액</p>
        <v-layout justify-space-between align-baseline wrap>
          <h1 class="font--m-1 color--nice-black">{{ loanData.amount | commaFormat }}원</h1>

          <span class="error--text font-weight-bold">
            {{ loanData.status | code('LoansLoan.Status') }}
          </span>
        </v-layout>
      </div>

      <v-divider></v-divider>

      <v-simple-table>
        <template v-slot:default>
          <tbody>
            <tr v-for="(info, index) in loanInfos" :key="index">
              <td class="px-1 color--nice-grey">{{ info.label }}</td>
              <td class="px-1 color--nice-black text-right font-weight-bold">
                {{ info.value }}
              </td>
            </tr>
            <tr v-if="request?.type === 'woori_crowd'">
              <td class="px-1 color--nice-grey">신청 유형</td>
              <td class="px-1 color--nice-black text-right font-weight-bold">
                <router-link :to="{ name: 'woori-crowd/detail', params: { uuid: request.uuid } }">
                  우리동네 크라우드 펀딩
                </router-link>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </div>
  </v-slide-y-transition>
</template>

<script>
import { toPercentage } from '@/util/mathUtil'
import { mapActions } from 'vuex'
export default {
  props: {
    loan: {
      required: true,
    },
    request: {
      required: false,
    },
  },
  data() {
    return {
      uuid: null,
      loanData: null,
    }
  },
  async created() {
    if (typeof this.loan === 'string') {
      this.uuid = this.loan
      this.loanData = await this.getLoansDetail(this.uuid)
    } else {
      this.uuid = this.loan.uuid
      this.loanData = this.loan
    }
  },
  methods: {
    ...mapActions('loan', ['getLoansDetail']),
  },
  computed: {
    loanInfos() {
      const infos = [
        {
          label: '이자율',
          value: `연 ${toPercentage(this.loanData.offer.interestRate)}%`,
        },
        {
          label: '연체이자율',
          value: `연 ${toPercentage(this.loanData.offer.overdueInterestRate)}%`,
        },
      ]

      // 연수수료만 있으면 연수수료로?
      if (this.loanData.offer.feeRate > 0 && !this.loanData.offer.commissionRate) {
        infos.push({
          label: '수수료율',
          value: `연 ${toPercentage(this.loanData.offer.feeRate)}%`,
        })
      } else {
        infos.push({
          label: '수수료율',
          value: `대출 금액의 ${toPercentage(this.loanData.offer.commissionRate, 2)}%`,
        })
      }

      if (this.loanData.offer.repaymentRatio) {
        infos.push({
          label: '상환 비율',
          value: `매출의 ${toPercentage(this.loanData.offer.repaymentRatio)}%`,
        })
      }

      if (this.loanData?.executedAt) {
        infos.push({
          label: '실행일시',
          value: `${this.$moment(this.loanData.executedAt).format('YYYY-MM-DD')}`,
        })
        infos.push({
          label: '만기일시',
          value: `${this.$moment(this.loanData.executedAt)
            .add(this.loanData.offer.periodInDays, 'days')
            .format('YYYY-MM-DD')}`,
        })
      } else {
        infos.push({
          label: '만기일',
          value: `대출금 지급일로부터 ${this.loanData.offer.periodInDays}일`,
        })
      }

      return infos
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep td {
  word-break: keep-all;
}
h1 {
  line-height: 1.2;
}
</style>
